// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './DropZone.themes';

type DropZoneProps = {
  children?: Node,
  className?: string,
  label?: string,
  minHeight?: string,
  number?: number,
  onClear?: ?() => void,
  theme?: string,
};

export function DropZone(props: DropZoneProps) {
  const {
    children,
    className,
    label,
    minHeight = '5rem',
    number,
    onClear,
    theme = 'default',
  } = props;

  const { thClear, thClearIconSize, thLabel, thNumber, thRoot, thRootFilled } = themes[theme];

  return children ? (
    <div className={classnames(className, thRootFilled)} style={{ minHeight }}>
      {children}
      <button className={thClear} onClick={onClear} type="button">
        <Icon name={ICONS.CROSS} width={thClearIconSize} />
      </button>
    </div>
  ) : (
    <div className={classnames(className, thRoot)} style={{ minHeight }}>
      {!!number && <span className={thNumber}>{number}</span>}
      {!!label && <span className={thLabel}>{label}</span>}
    </div>
  );
}
